module.exports = __webpack_public_path__ + "img/体系构建.71035b21.svg";